export default __webpack_public_path__ + "static/media/pubmatic-logo.38441d6f.svg";